import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "help-center-wrapper" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "main" }
const _hoisted_4 = { class: "card-header" }
const _hoisted_5 = ["innerHTML"]

import { ref, nextTick } from 'vue';
import { getAppHelpCenterTreeList } from '@/request/index';

interface Tree {
  label: string
  children?: Tree[]
}


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const treeRef = ref()
const loading = ref(false)
const treeData = ref([]);

const getData = () => {
  loading.value = true;
  getAppHelpCenterTreeList().then(res => {
    const data = res?.data?.data || [];
    treeData.value = data;
    const defaultCheckNode = data?.[0]?.children?.length ? (data?.[0]?.children?.[0]) : (data?.[0])
    currentNode.value = defaultCheckNode;
    loading.value = false;
    nextTick(() => {
      treeRef.value!.setCurrentKey(defaultCheckNode.id)
    })
  })
}

const currentNode = ref({});
const handleNodeClick = (data: Tree) => {
  if (data.children && data.children.length) {
    currentNode.value = {};
    return;
  }
  currentNode.value = data
}

const defaultProps = {
  children: 'children',
  label: 'name',
}

getData()


return (_ctx: any,_cache: any) => {
  const _component_el_tree = _resolveComponent("el-tree")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "header" }, "帮助中心", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_card, {
          class: "sider",
          shadow: "never"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_tree, {
              ref_key: "treeRef",
              ref: treeRef,
              style: {"width":"100%"},
              "node-key": "id",
              data: treeData.value,
              props: defaultProps,
              onNodeClick: handleNodeClick,
              "highlight-current": "",
              "current-node-key": currentNode.value.id
            }, null, 8, ["data", "current-node-key"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_card, {
          shadow: "never",
          class: "content"
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", null, _toDisplayString(currentNode.value.name), 1)
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: "card-body",
              innerHTML: currentNode.value.content
            }, null, 8, _hoisted_5)
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})